export const historyTabStyles = {
  root: "flex-1 overflow-y-auto",
  groupHeader: "px-4 pb-1 pt-4",
  groupLabel: "text-2xs font-semibold uppercase tracking-wider text-subtle",
  emptyDesc: "text-xs text-subtle",
};
